import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {getContentHeaders, postContentHeaders} from '../common/headers';
import {AuthHttp} from 'angular2-jwt';
import {BaseService} from '../base/service.base';
import {Machine} from '../models/machine.model';
import {Observable} from 'rxjs/Observable';
import {share} from 'rxjs/operator/share';

@Injectable()
export class MachinesService extends BaseService {
  private _machines$: BehaviorSubject<Machine[]>;
  private _dataStore: {
    machines: Machine[]
  };

  constructor(private _http: AuthHttp) {
    super();
    this._dataStore = {machines: []};
    this._machines$ = <BehaviorSubject<Machine[]>>new BehaviorSubject([]);
  }

  get machines$() {
    return this._machines$.asObservable();
  }

  public loadAll(filter: string = '') {
    this._http.get(`${this.baseApiUrl}/machines${filter}`, {headers: getContentHeaders})
      .map(response => response.json()).subscribe(result => {
      this._dataStore.machines = result;
      this._machines$.next(this._dataStore.machines);
    }, error => console.error('Could not load machines.'));
  }

  public load(id: any) {
    this._http.get(`${this.baseApiUrl}/machines/${id}`, {headers: getContentHeaders})
      .map(response => response.json()).subscribe(result => {
      let notFound = true;

      this._dataStore.machines.forEach((item, index) => {
        if (item._id === result._id) {
          this._dataStore.machines[index] = result;
          notFound = false;
        }
      });

      if (notFound) {
        this._dataStore.machines.push(result);
      }

      this._machines$.next(this._dataStore.machines);
    }, error => console.error('Could not load machine.'));
  }

  public create(machine: Machine): Observable<any> {
    const shareable = this._http.post(`${this.baseApiUrl}/machines`,
      JSON.stringify(machine), {headers: postContentHeaders})
      .map(response => response.json()).share();
    shareable.subscribe(result => {
      this._dataStore.machines.push(result);
      this._machines$.next(this._dataStore.machines);
    }, error => console.error('Could not create machine.'));

    return shareable;
  }

  public update(machine: Machine): Observable<any> {
    const shareable = this._http.put(`${this.baseApiUrl}/machines/${machine._id}`, JSON.stringify(machine),
      {headers: postContentHeaders}).map(response => response.json()).share();
    shareable.subscribe(result => {
      this._dataStore.machines.forEach((defi, i) => {
        if (defi._id === result._id) {
          this._dataStore.machines[i] = result;
        }
      });

      this._machines$.next(this._dataStore.machines);
    }, error => console.error('Could not update machine.'));

    return shareable;
  }

  public remove(machineId: string): Observable<any> {
    const shareable = this._http.delete(`${this.baseApiUrl}/machines/${machineId}`).share()
      shareable.subscribe(response => {
      this._dataStore.machines.forEach((t, i) => {
        if (t._id === machineId) {
          this._dataStore.machines.splice(i, 1);
        }
      });

      this._machines$.next(this._dataStore.machines);
    }, error => console.error('Could not delete machine.'));

    return shareable;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/machines.service.ts